import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const Title = styled.h3`
    font-size: ${({ theme }) => theme.fontSizes[7]};
    line-height: 1.4;
    font-weight: 700;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const ChipsContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 0.75rem;

    & > * {
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
    }
`;
